import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { OpenAPIService } from '../../services/openAPI.service';

@Component({
  selector: 'medical-photo-thumb',
  templateUrl: './medical-photo-thumb.component.html',
  styleUrls: [
    './medical-photo-thumb.component.scss'
  ]
})
export class MedicalPhotoThumbComponent implements OnInit {

  @Input() id: any = null;
  @Input() photoPlaceholder: string | null = null;

  @Output() onClick = new EventEmitter<any>();

  photo: any = null;

  spin: boolean = false;

  imageUrl: string | null = null;
  imageUrlBackground: string | null = null;

  constructor(
    private translate: TranslateService,
    private apiService: OpenAPIService
  ) { }

  ngOnInit() {
    this._loadMedicalPhoto(this.id);
  }

  _onClick() {
    this.onClick.emit(this.photo);
  }

  _loadMedicalPhoto(id: number) {
    this.spin = true;
    this.apiService.getDetails('medicalphotos', id).subscribe({
      next: (response: any) => {
        this.photo = { ...response.data };
        const _mimeType = this.photo.mime_type || 'image/jpeg';
        this.imageUrl = `data:${_mimeType};base64,${this.photo.image}`;
        this.imageUrlBackground = `url('data:${_mimeType};base64,${this.photo.image}')`;
        this.spin = false;
      },
      error: (error: any) => {
        console.log('_loadMedicalPhoto error', error);
        this.spin = false;
      }
    });
  }

  isNotReady() {
    return this.photo && this.photo.photo_status === 'not_ready';
  }

  getPhotoColor(photo: any) {
    if (photo) {
      switch (photo.photo_status) {
        case 'not_ready':
          return 'medium';
        case 'ready':
          return 'primary';
        case 'processing':
          return 'warning';
        case 'processed':
          return 'primary';
        default:
      }
    }
    return 'medium';
  }
}
